export function withAdaptors(...adaptors: ((node: JSX.Element) => JSX.Element)[]) {
    return (node: JSX.Element) => adaptors.reduceRight((n, w) => w(n), node);
}
